import { Fragment, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useAuth } from 'context/UseContext';
import { useAuthString } from 'auth/useAuthStorage';



function RashidKpis() {

    const [, setRenderState] = useState()
    const { user } = useAuth();
    const METABASE_SITE_URL = "https://analytics.galaxyshipping.com";
    const dashboardPermission = process.env.REACT_APP_METABASE_IS_ENABLED;

    const rashidKpisDashboard = useAuthString('rashidKpisDashboard');
    let iframeUrl = METABASE_SITE_URL + "/embed/dashboard/" + rashidKpisDashboard + "#bordered=false&titled=true";

    useEffect(() => {
        if (rashidKpisDashboard) {
            setRenderState(rashidKpisDashboard)
        }

    }, [rashidKpisDashboard])
    return (
        <Fragment>
            {
                dashboardPermission === "true" ? (
                    <>

                        {user?.user_type !== 'C' && (
                            <Box sx={{ height: '100vh' }}><iframe
                                title="Rashid KPIs analytics dashboard"
                                src={iframeUrl}
                                frameBorder={0}
                                width={'100%'}
                                height={'100%'}
                                allowTransparency
                            />
                            </Box>

                        )}

                    </>
                ) : (
                    <></>
                )
            }


        </Fragment>);
}

export default RashidKpis;
